<template>
  <div class="e-attachment">
    <e-close-badge class="e-attachment__delete" @click="$emit('click:delete')" />
    <img
      v-if="fileType(file.type) === 'displayImage' && !file.error && !file.loading && file.success"
      alt="attachment"
      class="e-attachment__image"
      :src="file.blob"
    />
    <e-tooltip v-else-if="fileType(file.type) !== 'displayImage' && !file.error && !file.loading && file.success" top>
      <template #activator="{ on }">
        <div class="e-attachment__file" v-on="on">
          <span :class="attachmentIcon(file)" />
        </div>
      </template>
      {{ file.name }}
    </e-tooltip>

    <e-tooltip v-if="file.error" top>
      <template #activator="{ on }">
        <div class="e-attachment__bar e-attachment__bar__error" v-on="on">
          <div class="e-attachment__bar__error__icon">
            <span class="icon-close-sign"></span>
          </div>
        </div>
      </template>
      {{ file.error }}
    </e-tooltip>
    <div v-else-if="!file.success && !file.error" class="e-attachment__bar e-attachment__bar__progress-bar">
      <span>
        <v-progress-circular width="2" size="14" :value="file.progress" />
      </span>
      <span class="caption-2 mt-1">
        {{ file.progress + '%' }}
      </span>
    </div>
  </div>
</template>
<script>
import ECloseBadge from './ECloseBadge'
import { VProgressCircular } from 'vuetify/lib'
import { fileType, attachmentIcon } from '../../utils'

export default {
  name: 'EAttachment',
  components: { ECloseBadge, VProgressCircular },
  props: {
    file: {
      type: Object,
      default: undefined,
    },
  },
  methods: {
    fileType,
    attachmentIcon,
  },
}
</script>
